var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXtwitterBtint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.112153 0L17.8722 23.1655L0 42H4.02232L19.6694 25.5101L32.3119 42H46L27.2407 17.5315L43.876 0H39.8537L25.4435 15.1869L13.8003 0H0.112153ZM6.02728 2.89031H12.3156L40.084 39.1092H33.7956L6.02728 2.89031Z",
    fill: "#212936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtwitterBtint);
export default __webpack_public_path__ + "static/media/xtwitter-btint.7c865b62fc5801f68d48a009dafb2fbb.svg";
export { ForwardRef as ReactComponent };